import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import VideoPlayer from './pages/VideoPlayer';
import SearchResults from './pages/SearchResults';
import { initializeTheme } from './utils/localStorage';
import './App.css';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    initializeTheme();
  }, []);

  return (
    <Router>
      <div className="App">
        <Header 
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          onSearch={setSearchQuery}
        />
        <div className="app-container">
          <Sidebar isOpen={sidebarOpen} />
          <main className={`main-content ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/video/:videoId" element={<VideoPlayer />} />
              <Route path="/search" element={<SearchResults query={searchQuery} />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
